import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export type VisibilityOptions = "Everyone" | "People You Follow" | "Community";

export type communityVisibiltyOption = {
    type: "Community";
    ids: string[];
};

export type FeedFormState = {
    formType: "post" | "incident" | "reply";
    visibility: VisibilityOptions;
    selectedCommunities: string[];
    engajmentModalPosition: { left: number; top: number };
    openGifsModal: boolean;
};

const initialState: FeedFormState = {
    formType: "post",
    visibility: "Everyone",
    selectedCommunities: [],
    engajmentModalPosition: { left: 0, top: 0 },
    openGifsModal: false
};

export const feedFormSlice = createSlice({
    name: "feedFrom",
    initialState,
    reducers: {
        setPost: (state) => {
            state.formType = "post";
        },
        setIncident: (state) => {
            state.formType = "incident";
        },
        setReply: (state) => {
            state.formType = "reply";
        },
        setVisibility: (state, action: PayloadAction<VisibilityOptions>) => {
            state.visibility = action.payload;
        },
        addSelectedCommunity: (state, action: PayloadAction<string>) => {
            state.selectedCommunities = [
                ...state.selectedCommunities,
                action.payload
            ];
        },
        addSelectedCommunities: (state, action: PayloadAction<string[]>) => {
            state.selectedCommunities = action.payload;
        },
        removeSelectedCommunity: (state, action: PayloadAction<string>) => {
            state.selectedCommunities = state.selectedCommunities.filter(
                (i) => i != action.payload
            );
        },
        emptySelectedCommunities: (state) => {
            state.selectedCommunities = [];
        },
        setEngajmnetModalPostion: (
            state,
            action: PayloadAction<{ left: number; top: number }>
        ) => {
            state.engajmentModalPosition = action.payload;
        },
        openFeedFormGifs: (state) => {
            state.openGifsModal = true;
        },
        closeFeedFormGifs: (state) => {
            state.openGifsModal = false;
        }
    }
});

export const {
    setPost,
    setIncident,
    setReply,
    setVisibility,
    addSelectedCommunity,
    addSelectedCommunities,
    removeSelectedCommunity,
    emptySelectedCommunities,
    setEngajmnetModalPostion,
    openFeedFormGifs,
    closeFeedFormGifs
} = feedFormSlice.actions;

export default feedFormSlice.reducer;
